import React from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import RedRoundBtn from "../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";
import Select from "react-select";
import "./Common_Enquiry_Form.css";
import { useNavigate } from "react-router-dom";
import { EnquiryForm } from "../../../utils/apis/form/form";
import { RegxExpression } from "../../../utils/common";

const Common_Enquiry_Form = () => {
  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const data = [
    { value: "HOME LOAN", label: "HOME LOAN" },
    { value: "PERSONAL LOAN", label: "PERSONAL LOAN" },
    { value: "CAR LOAN", label: "CAR LOAN" },
    { value: "CREDIT CARD LOAN", label: "CREDIT CARD LOAN" },
  ];

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("message", data?.message);
    formData.append("loan_type", data?.loan_type?.value);
    formData.append("name", data?.name);
    formData.append("email", data?.email);
    formData.append("contact_no", data?.contact_no);

    const res = await EnquiryForm(formData);
    if (res?.success) {
      reset();
      navigate("/thank-you")
    } else {
    }
  };

  return (
    <section className="Common_Enquiry_Form">
      <div className="enquiry_form_div">
        <div className="heading_div">
          <p className="title">Enquiry Form</p>
        </div>

        <div className="form_holder">
          <Form className="enquiry_form" onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="form-group">
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter Full Name"
                {...register("name", {
                  required: "Name is required",
                })}
                onKeyDown={(event) => {
                  if (!RegxExpression.name.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              {errors?.name && (
                <span className="invalid-feedback d-block">
                  {errors.name.message}
                </span>
              )}
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter Email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: RegxExpression.email,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors?.email && (
                <span className="invalid-feedback d-block">
                  {errors.email.message}
                </span>
              )}
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Control
                type="tel"
                name="contact_no"
                placeholder="Enter Mobile Number"
                {...register("contact_no", {
                  required: "Mobile number is required",
                  pattern: {
                    value: /^[6-9]\d{9}$/, // Ensures a 10-digit valid Indian mobile number
                    message: "Enter a valid 10-digit mobile number",
                  },
                })}
                maxLength={10} // Prevents typing more than 10 digits
                onKeyDown={(event) => {
                  if (
                    !RegxExpression.phone.test(event.key) &&
                    event.key !== "Backspace" &&
                    event.key !== "ArrowLeft" &&
                    event.key !== "ArrowRight"
                  ) {
                    event.preventDefault();
                  }
                }}
              />
              {errors?.contact_no && (
                <span className="invalid-feedback d-block">
                  {errors.contact_no.message}
                </span>
              )}
            </Form.Group>

            <Form.Group controlId="formFirstName">
              <Controller
                name="loan_type" // name of the field
                {...register("loan_type", {
                  required: "Select Loan type",
                })}
                control={control}
                render={({ field }) => (
                  <Select
                    options={data}
                    placeholder="Loan type"
                    styles={{
                      // control: (baseStyles) => ({
                      //   ...baseStyles,
                      //   borderColor: errors.loan_type ? "red" : baseStyles,
                      // }),
                    }}
                    {...field}
                  />
                )}
              />

              {errors.loan_type && (
                <span className="invalid-feedback d-block">{errors.loan_type.message}</span>
              )}
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Control
                type="text"
                name="name"
                placeholder="Your Message (if any)"
                {...register("message", {
                  required: "Message is required",
                })}
              />
              {errors?.message && (
                <span className="invalid-feedback d-block">
                  {errors.message.message}
                </span>
              )}
            </Form.Group>

            <div className="submit_btn">
              <RedRoundBtn
                btn_name={"Submit"}
                type="submit"
              // onClick={() => {
              //   navigate("/loan-calculator");
              // }}
              />
            </div>
          </Form>
        </div>
      </div>
    </section>
  );
};

export default Common_Enquiry_Form;
